import type { PortableTextBlock } from '@portabletext/types'
import { format, parseISO } from 'date-fns'
import { IMainContent } from '../types/blogPost'
import { categoryTags } from '../lib/tags'
import PortableText from './PortableText'
import AuthorList from './author-list'

import { mainContent } from './BlogPost.module.css'

function MainContent({
  topImage,
  publishedAt,
  updatedOn,
  categories,
  authors,
  excerpt,
  content,
}: IMainContent) {
  return (
    <main id="main-content" className={mainContent}>
      {topImage && <PortableText value={topImage as PortableTextBlock} />}
      {publishedAt && (
        <time
          dateTime={format(parseISO(publishedAt), 'yyyy-MM-dd')}
          className="mb-2 text-sm text-neutral-500"
        >
          Published: {format(parseISO(publishedAt), 'LLLL d, yyyy')}
        </time>
      )}
      {updatedOn && (
        <time
          dateTime={format(parseISO(updatedOn), 'yyyy-MM-dd')}
          className="mb-2 text-sm text-neutral-500"
        >
          Updated: {format(parseISO(updatedOn), 'LLLL d, yyyy')}
        </time>
      )}
      {categories && (
        <div className="my-4 flex items-center gap-4 text-sm">
          <p>Categories:</p>
          {categoryTags(categories)}
        </div>
      )}
      {authors && (
        <div className="border-(--color-border) border-y">
          <AuthorList items={authors} />
        </div>
      )}
      {excerpt && (
        <p className="bg-(--bg-color-dim) my-4 rounded-lg px-6 py-4 text-base/7 font-bold">
          {excerpt}
        </p>
      )}
      {content && <PortableText value={content as PortableTextBlock[]} />}
    </main>
  )
}

export default MainContent
